import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';

import BuscaCadastroServices from '../../services/buscaCadastro';
import './styles.css';

// Busca por CPF, e-mail ou nome: se a pessoa tem cadastro no banco da agencia
// e em qual contrato. O servidor procura nos formandos, no login e nos
// contatos da comissao e nos dados de faturamento (BuscaCadastroService.js).

const PAPEIS = {
  formando: 'Formando',
  comissao: 'Comissão',
  contato: 'Contato da comissão',
  faturamento: 'Faturamento e entrega',
  equipe: 'Equipe da agência'
};

// A pesquisa de contratos (obterContratoLikePeloNumero) nao mostra estes
const FORA_DA_PESQUISA = {
  deletado: 'Excluído',
  arquivado: 'Arquivado',
  finalizado: 'Finalizado'
};

function apenasDigitos (valor) {
  return String(valor || '').replace(/\D/g, '');
}

// O mesmo criterio do servidor: com "@" e e-mail; 11 numeros CPF, 14 CNPJ;
// sem numeros e com pelo menos 3 letras, nome.
export function interpretar (termo) {
  const texto = String(termo || '').trim().replace(/\s+/g, ' ');
  if (texto.indexOf('@') !== -1) return { tipo: 'email', valor: texto.toLowerCase() };
  const digitos = apenasDigitos(texto);
  if (digitos.length === 11 || digitos.length === 14) return { tipo: 'documento', valor: digitos };
  if (!digitos && texto.replace(/[^A-Za-zÀ-ÿ]/g, '').length >= 3) return { tipo: 'nome', valor: texto, palavras: texto.split(' ') };
  return null;
}

// Para comparar nomes como o banco: sem acento e sem maiuscula
function semAcento (texto) {
  return String(texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}

export function nomeTemAsPalavras (nome, palavras) {
  const alvo = semAcento(nome);
  return Boolean(nome) && (palavras || []).every((palavra) => alvo.indexOf(semAcento(palavra)) !== -1);
}

export function formatarDocumento (valor) {
  const digitos = apenasDigitos(valor);
  if (digitos.length === 11) return digitos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  if (digitos.length === 14) return digitos.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  return valor || '';
}

function mensagemDoErro (erro, padrao) {
  return (erro && erro.response && erro.response.data && erro.response.data.error) || padrao;
}

function vazio () {
  return <span className="text-muted">—</span>;
}

class BuscaCadastro extends React.Component {

  state = {
    termo: '',
    aviso: null,
    buscando: false,
    resultado: null
  }

  podeVer () {
    return Boolean(this.props.usuario) && this.props.usuario.tipo === 'administrador';
  }

  buscar (evento) {
    evento.preventDefault();
    if (!interpretar(this.state.termo)) {
      this.setState({ aviso: 'Digite um CPF (11 números), um CNPJ (14 números), um e-mail ou pelo menos 3 letras do nome.' });
      return;
    }
    this.setState({ buscando: true, aviso: null, resultado: null });
    new BuscaCadastroServices().buscar(this.state.termo).then((resultado) => {
      this.setState({ buscando: false, resultado });
    }).catch((erro) => {
      this.setState({ buscando: false, aviso: mensagemDoErro(erro, 'Não foi possível buscar o cadastro.') });
    });
  }

  // O valor que bateu com a busca fica destacado
  achou (vinculo, campo) {
    const { busca } = this.state.resultado;
    if (busca.tipo === 'documento') return campo === 'documento' && apenasDigitos(vinculo.documento) === busca.valor;
    if (busca.tipo === 'nome') return campo === 'nome' && nomeTemAsPalavras(vinculo.nome, busca.palavras);
    if (campo === 'email') return String(vinculo.email || '').trim().toLowerCase() === busca.valor;
    if (campo === 'login') return String(vinculo.login || '').trim().toLowerCase() === busca.valor;
    return false;
  }

  _renderValor (vinculo, campo, texto) {
    if (!texto) return vazio();
    return <span className={this.achou(vinculo, campo) ? 'bc-achado' : ''}>{texto}</span>;
  }

  _renderPapel (vinculo) {
    return (
      <div className="bc-papeis">
        <span className={`bc-selo bc-selo--${vinculo.papel}`}>{PAPEIS[vinculo.papel] || vinculo.papel}</span>
        {vinculo.equipe ? <span className="bc-selo">{vinculo.equipe}</span> : null}
        {vinculo.membroComissao ? <span className="bc-selo bc-selo--membro">membro da comissão</span> : null}
        {vinculo.principal ? <span className="bc-selo">principal</span> : null}
      </div>
    );
  }

  _renderVinculos (vinculos) {
    return (
      <div className="table-responsive">
        <table className="table bc-tabela">
          <thead>
            <tr>
              <th>Onde</th>
              <th>Nome</th>
              <th>E-mail</th>
              <th>CPF / CNPJ</th>
              <th>Celular</th>
              <th>Curso</th>
            </tr>
          </thead>
          <tbody>
            {vinculos.map((vinculo, i) => (
              <tr key={i}>
                <td>{this._renderPapel(vinculo)}</td>
                <td>{this._renderValor(vinculo, 'nome', vinculo.nome)}</td>
                <td>
                  {this._renderValor(vinculo, 'email', vinculo.email)}
                  {vinculo.login ? <div className="bc-login">login: {this._renderValor(vinculo, 'login', vinculo.login)}</div> : null}
                </td>
                <td className="bc-documento">{this._renderValor(vinculo, 'documento', formatarDocumento(vinculo.documento))}</td>
                <td>{vinculo.celular || vazio()}</td>
                <td>{vinculo.curso || vazio()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  _renderContrato (contrato) {
    const fora = FORA_DA_PESQUISA[contrato.status];
    return (
      <div key={contrato.id} className="bc-contrato">
        <div className="bc-contrato-topo">
          <h4 className="bc-contrato-titulo">
            {contrato.numero ? `Contrato ${contrato.numero}` : `Contrato sem número (id ${contrato.id})`}
            {fora ? <span className="bc-selo bc-selo--alerta">{fora}</span> : null}
            {contrato.cancelado ? <span className="bc-selo bc-selo--alerta">Cancelado</span> : null}
          </h4>
          <div className="bc-contrato-dados">
            {contrato.dataFormatura ? <span>Formatura {moment(contrato.dataFormatura).format('DD/MM/YYYY')}</span> : null}
            {contrato.atendente ? <span>Atendente {contrato.atendente}</span> : null}
            {contrato.numero && !fora ? (
              <Link className="btn btn-default btn-xs" to={`/contratos/pesquisar?contrato=${contrato.numero}`}>
                <i className="fa fa-external-link"></i> Abrir contrato
              </Link>
            ) : null}
          </div>
        </div>
        {this._renderVinculos(contrato.vinculos)}
      </div>
    );
  }

  _renderResultado () {
    const { resultado, buscando } = this.state;
    if (buscando) return <div className="bc-vazio"><i className="fa fa-spinner fa-spin"></i> Buscando…</div>;
    if (!resultado) return null;

    const { busca, contratos, semContrato, limitado } = resultado,
      procurado = busca.tipo === 'documento' ? `o ${busca.valor.length === 14 ? 'CNPJ' : 'CPF'} ${formatarDocumento(busca.valor)}`
        : busca.tipo === 'nome' ? `o nome "${busca.valor}"`
        : `o e-mail ${busca.valor}`;

    if (!contratos.length && !semContrato.length) {
      return <div className="bc-vazio">Nenhum cadastro com {procurado}.</div>;
    }
    return (
      <div>
        <p className="bc-resumo">
          {contratos.length === 1 ? 'Encontrado em 1 contrato' : `Encontrado em ${contratos.length} contratos`} com {procurado}.
        </p>
        {limitado ? (
          <div className="bc-aviso" role="status">
            Muita gente com esse nome: aparecem só os cadastros mais recentes. Digite mais partes do nome (por exemplo, nome e sobrenome) para achar a pessoa.
          </div>
        ) : null}
        {contratos.map((contrato) => this._renderContrato(contrato))}
        {semContrato.length ? (
          <div className="bc-contrato">
            <div className="bc-contrato-topo">
              <h4 className="bc-contrato-titulo">Sem contrato</h4>
            </div>
            {this._renderVinculos(semContrato)}
          </div>
        ) : null}
      </div>
    );
  }

  render () {
    if (!this.podeVer()) return <Redirect to="/unauthorized" />;
    return (
      <div className="bc-pagina">
        <div className="box">
          <div className="box-body">
            <h3 className="bc-titulo">Buscar cadastro</h3>
            <p className="bc-subtitulo">
              Digite o CPF, o e-mail ou o nome para saber se a pessoa tem cadastro e em qual contrato está. Procura nos formandos, no login e nos contatos da comissão e nos dados de faturamento.
            </p>
            <form className="bc-form" onSubmit={this.buscar.bind(this)}>
              <div className="input-group bc-busca">
                <input
                  type="text"
                  className="form-control"
                  placeholder="CPF, e-mail ou nome"
                  aria-label="CPF, e-mail ou nome"
                  autoFocus
                  value={this.state.termo}
                  onChange={(e) => this.setState({ termo: e.target.value })}
                />
                <div className="input-group-btn">
                  <button type="submit" className="btn btn-primary btn-flat" disabled={this.state.buscando}>
                    <i className="fa fa-search"></i> Buscar
                  </button>
                </div>
              </div>
            </form>
            {this.state.aviso ? <div className="bc-aviso" role="alert">{this.state.aviso}</div> : null}
            {this._renderResultado()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado
  };
};

export default connect(mapStateToProps)(BuscaCadastro);



// WEBPACK FOOTER //
// ./src/views/BuscaCadastro/index.js